import Sidebar from '../components/sidebar/Sidebar';
import React, {useState} from 'react';
import Footer from '../components/footer/Footer';
import FormsACADetails from "../components/forms/FormsW2Details";
import NavbarForms from "../components/navbar/NavbarForms";


const FormsACA = () => {

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    return (
      <>
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <NavbarForms toggle={toggle} />
          <FormsACADetails/>
        <Footer/>
      </>
  );
};

export default FormsACA;
